__turbopack_context__.v({
  "imageBannerContainer": "ImageBanner-module-scss-module__A1G_qa__imageBannerContainer",
  "imageBannerContent": "ImageBanner-module-scss-module__A1G_qa__imageBannerContent",
  "imageBannerContentCenterAlign": "ImageBanner-module-scss-module__A1G_qa__imageBannerContentCenterAlign",
  "imageBannerDescriptionContent": "ImageBanner-module-scss-module__A1G_qa__imageBannerDescriptionContent",
  "imageBannerHeading": "ImageBanner-module-scss-module__A1G_qa__imageBannerHeading",
});
